export default {
  IMG_EXT: ['png', 'jpg', 'jpeg', 'heic'],
  DOC_EXT: ['pdf']
}